module.exports = __webpack_public_path__ + "img/icon_2.244b5ef6.png";